<template>
  <el-config-provider :locale="elLocale">
    <div class="main-layout">
      <el-container class="layout-container">
        <!-- 侧边栏 -->
        <el-aside
          :width="sidebarWidth"
          class="sidebar"
          :class="{ 'is-collapse': isCollapse }"
        >
          <div class="logo" @click="toggleCollapse">
            <span v-if="!isCollapse">{{ t("message.system.title") }}</span>
            <el-icon v-else><Fold /></el-icon>
          </div>

          <el-menu
            :default-active="activeMenu"
            class="el-menu-vertical"
            :collapse="isCollapse"
            :collapse-transition="false"
            :default-openeds="defaultOpeneds"
            router
            :background-color="menuBgColor"
            :text-color="menuTextColor"
            :active-text-color="menuActiveColor"
          >
            <!-- ===== 动态渲染菜单（根据后端权限数据） ===== -->
            <template v-for="menu in menuList" :key="menu.id">
              <!-- 有子菜单：显示为 el-sub-menu -->
              <el-sub-menu v-if="menu.children && menu.children.length > 0" :index="String(menu.id)">
                <template #title>
                  <el-icon v-if="menu.icon"><component :is="getIconComponent(menu.icon)" /></el-icon>
                  <span>{{ getMenuName(menu) }}</span>
                </template>
                <template v-for="child in menu.children" :key="child.id">
                  <el-menu-item v-if="!child.children || child.children.length === 0" :index="getMenuPath(child)">
                    <el-icon v-if="child.icon"><component :is="getIconComponent(child.icon)" /></el-icon>
                    <span>{{ getMenuName(child) }}</span>
                  </el-menu-item>
                  <!-- 支持多级子菜单 -->
                  <el-sub-menu v-else :index="String(child.id)">
                    <template #title>
                      <el-icon v-if="child.icon"><component :is="getIconComponent(child.icon)" /></el-icon>
                      <span>{{ getMenuName(child) }}</span>
                    </template>
                    <el-menu-item v-for="subChild in child.children" :key="subChild.id" :index="getMenuPath(subChild)">
                      <el-icon v-if="subChild.icon"><component :is="getIconComponent(subChild.icon)" /></el-icon>
                      <span>{{ getMenuName(subChild) }}</span>
                    </el-menu-item>
                  </el-sub-menu>
                </template>
              </el-sub-menu>
              
              <!-- 无子菜单：直接显示为 el-menu-item -->
              <el-menu-item v-else :index="getMenuPath(menu)">
                <el-icon v-if="menu.icon"><component :is="getIconComponent(menu.icon)" /></el-icon>
                <span>{{ getMenuName(menu) }}</span>
              </el-menu-item>
            </template>

            <!-- ===== 项目动态菜单 ===== -->
            <!-- <el-sub-menu index="5">
              <template #title>
                <el-icon><Monitor /></el-icon>
                <span>{{ t("message.menu.project") }}</span>
              </template>              
              <el-menu-item 
                v-for="item in menuItems" 
                :key="item.id"
                :index="`/main/clientProjectDeail?businessId=${item.id}&businessName=${item.name}`"
              >
                <span>{{ item.name }}</span>
              </el-menu-item>   
            </el-sub-menu> -->
          </el-menu>
        </el-aside>

        <el-container class="main-container">
          <!-- 顶部导航栏 -->
          <el-header class="header">
            <div class="header-left">
              <el-button
                type="text"
                @click="toggleCollapse"
                class="collapse-btn"
              >
                <el-icon :size="18">
                  <component :is="isCollapse ? 'Expand' : 'Fold'" />
                </el-icon>
              </el-button>

              <el-breadcrumb separator="/" class="breadcrumb">
                <el-breadcrumb-item v-for="item in breadcrumb" :key="item.path">
                  {{  '' }}
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>

            <div class="header-right">
              <el-button-group class="lang-switch">
                <el-button
                  :type="$i18n.locale === 'zh-CN' ? 'primary' : ''"
                  @click="changeLang('zh-CN')"
                  size="small"
                >
                  中文
                </el-button>
                <el-button
                  :type="$i18n.locale === 'en' ? 'primary' : ''"
                  @click="changeLang('en')"
                  size="small"                  
                >
                  English
                </el-button>
              </el-button-group>

              <el-icon size="20"><UserFilled /></el-icon>
              <el-dropdown @command="handleCommand" trigger="click">
                <span class="user-dropdown">
                  {{ username }}
                  <el-icon><ArrowDown /></el-icon>
                </span>

                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="profile">
                      <el-icon><User /></el-icon>
                      {{ t("message.user.profile") }}
                    </el-dropdown-item>
                    <el-dropdown-item command="logout" divided>
                      <el-icon><SwitchButton /></el-icon>
                      {{ t("message.user.logout") }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </el-header>

          <!-- 主内容区 -->
          <el-main class="main-content">
            <router-view v-slot="{ Component }">
              <transition name="fade-transform" mode="out-in">
                <component :is="Component" />
              </transition>
            </router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </el-config-provider>
</template>

<script setup>
import {
  Fold,
  Location,
  Tools,
  OfficeBuilding,
  Connection,
  List,
  Files,
  DataLine,
  Link,
  Message,
  TrendCharts,
  Timer,
  Menu,
  User,
  Key,
  ArrowDown,
  UserFilled,
  SwitchButton,
  Monitor,
  Setting,
  Grid,
  Edit,
  Document,
  Warning,
  Collection,
  Checked,
  Clock,
  Search,
  Download,
  Upload,
  Share,
  Refresh,
  Expand,
} from "@element-plus/icons-vue";

import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from "vue-i18n";
import { loginOut, hanldChangeUserlang } from "@/api/UserManager";
//import { protocolbusinessList } from "@/api/ProjectManger";
import { getCurrentUserMenus } from "@/api/MenuManager";

const { t, locale } = useI18n();
const store = useStore();
const route = useRoute();
const router = useRouter();

// ===== 菜单数据 =====
const menuList = ref([]);
//const menuItems = ref([]);
const defaultOpeneds = ref(['1', '5']);

// ===== 计算属性 =====
const isCollapse = computed(() => store.state.isMenuCollapsed);
const sidebarWidth = computed(() => (isCollapse.value ? "64px" : "200px"));

const activeMenu = computed(() => {
  const path = route.path;
  const businessId = route.query.businessId;
  const businessName = route.query.businessName;

  if (path === '/main/clientProjectDeail' && businessId) {
    return `${path}?businessId=${businessId}&businessName=${businessName}`;
  }
  return path;
});

const breadcrumb = computed(() => {
  return route.matched
    .filter((item) => item.name)
    .map((item) => ({
      path: item.path,
      meta: item.meta || {},
      name: item.name || "",
    }));
});

const username = computed(() => {
  return store.state.user?.username || t("message.user.guest");
});

const menuBgColor = ref("#304156");
const menuTextColor = ref("#bfcbd9");
const menuActiveColor = ref("#409EFF");
const elLocale = ref(null);

// ===== 图标映射 =====
const iconMap = {
  'Location': Location,
  'Tools': Tools,
  'OfficeBuilding': OfficeBuilding,
  'Connection': Connection,
  'List': List,
  'Files': Files,
  'DataLine': DataLine,
  'Link': Link,
  'Message': Message,
  'TrendCharts': TrendCharts,
  'Timer': Timer,
  'Menu': Menu,
  'User': User,
  'Key': Key,
  'Monitor': Monitor,
  'Setting': Setting,
  'Grid': Grid,
  'Edit': Edit,
  'Document': Document,  
  'Warning':Warning,    
  'Collection': Collection,
  'Checked': Checked,
  'Clock': Clock,
  'Search': Search,
  'Download': Download,
  'Upload': Upload,
  'Share': Share,
  'Refresh': Refresh,
  'UserFilled': UserFilled,
  'SwitchButton': SwitchButton,
  'ArrowDown': ArrowDown,
  'Fold': Fold,
  'Expand': Expand,
};

// ===== 获取图标组件 =====
const getIconComponent = (iconName) => {
  if (!iconName) return null;
  const name = iconName.replace(/^el-icon-/, '');
  return iconMap[name] || null;
};

// ===== 获取菜单显示名称（根据语言） =====
const getMenuName = (menu) => {
  if (!menu) return '';
  const isEn = locale.value === 'en';
  if (isEn && menu.name_en) {
    return menu.name_en;
  }
  return menu.name;
};

// ===== 获取菜单路径 =====
const getMenuPath = (menu) => {
  if (!menu) return '#';
  if (menu.query) {
    return `${menu.path}?${menu.query}`;
  }
  return menu.path || '#';
};


// ===== 加载用户菜单权限 =====

const loadUserMenusFromService = async () => {
  try {
    const res = await getCurrentUserMenus();
    if (res?.success && res.data) {
      // 1. 构建菜单树用于显示
      const menuTree = buildMenuTree(res.data);
      menuList.value = menuTree;
      
      // 2. ✅ 将原始菜单数据回写到 Vuex store
      store.commit('user/SET_MENUS', res.data);
      
      // 3. ✅ 同时更新 sessionStorage 缓存
      sessionStorage.setItem('menus', JSON.stringify(res.data));
      
      console.log('✅ 菜单加载成功，共', menuList.value.length, '个顶级菜单');
      console.log('✅ 已回写到 Vuex store 和 sessionStorage');
      
      // 设置默认展开的菜单
      if (menuList.value.length > 0) {
        const openIds = menuList.value.map(m => String(m.id));
        defaultOpeneds.value = [...openIds, '5'];
      }
    } else {
      console.warn('⚠️ 获取菜单失败，使用默认菜单');
      menuList.value = getDefaultMenus();
    }
  } catch (error) {
    console.error('❌ 加载菜单异常:', error);
    menuList.value = getDefaultMenus();
  }
};

const loadUserMenus = async () => {
  try {

    // 从 Vuex store 获取缓存的用户数据    
    const cachedMenus = store.state.user?.menus;        
    console.log('缓存的菜单数量:', cachedMenus?.length || 0);
    
    // 如果已经有缓存的菜单数据，直接使用
    if (cachedMenus && cachedMenus.length > 0) {
      console.log('使用缓存的菜单数据');
      menuList.value = buildMenuTree(cachedMenus);
      
      // 设置默认展开的菜单
      if (menuList.value.length > 0) {
        const openIds = menuList.value.map(m => String(m.id));
        defaultOpeneds.value = [...openIds, '5'];
      }      
      return;
    }
    //加载菜单
    await loadUserMenusFromService();     
  } catch (error) {
    console.error('加载菜单异常:', error);
    menuList.value = getDefaultMenus();
  }
};

// ===== 构建菜单树 =====
const buildMenuTree = (data) => {
  const map = {};
  const roots = [];

  data.forEach(item => {
    map[item.id] = { 
      ...item, 
      children: [],
    };
  });

  data.forEach(item => {
    if (item.parent_id && map[item.parent_id]) {
      map[item.parent_id].children.push(map[item.id]);
    } else {
      roots.push(map[item.id]);
    }
  });

  const sortTree = (nodes) => {
    nodes.sort((a, b) => (a.order_num || 0) - (b.order_num || 0));
    nodes.forEach(node => {
      if (node.children && node.children.length > 0) {
        sortTree(node.children);
      }
    });
    return nodes;
  };

  return sortTree(roots);
};

// ===== 默认菜单（兜底） =====
const getDefaultMenus = () => {
  const isEn = locale.value === 'en';
  return [
    {
      id: 1,
      name: isEn ? 'Navigation' : '导航菜单',
      name_en: 'Navigation',
      type: 'M',
      path: '',
      icon: 'Location',
      children: [
        {
          id: 101,
          name: isEn ? 'Dashboard' : '仪表板',
          name_en: 'Dashboard',
          type: 'C',
          path: '/main/dashboard',
          icon: 'Menu'
        }
      ]
    },
    {
      id: 2,
      name: isEn ? 'System' : '系统管理',
      name_en: 'System',
      type: 'M',
      path: '',
      icon: 'Tools',
      children: [
        {
          id: 201,
          name: isEn ? 'Organization' : '企业管理',
          name_en: 'Organization',
          type: 'C',
          path: '/main/organization',
          icon: 'OfficeBuilding'
        },
        {
          id: 202,
          name: isEn ? 'Users' : '用户管理',
          name_en: 'Users',
          type: 'C',
          path: '/main/users',
          icon: 'User'
        },
        {
          id: 203,
          name: isEn ? 'Roles' : '角色管理',
          name_en: 'Roles',
          type: 'C',
          path: '/main/roles',
          icon: 'Key'
        },
        {
          id: 204,
          name: isEn ? 'Operation Log' : '操作日志',
          name_en: 'Operation Log',
          type: 'C',
          path: '/main/operationLog',
          icon: 'List'
        }
      ]
    },
    {
      id: 3,
      name: isEn ? 'Device' : '设备管理',
      name_en: 'Device',
      type: 'M',
      path: '',
      icon: 'Connection',
      children: [
        {
          id: 301,
          name: isEn ? 'Device List' : '设备列表',
          name_en: 'Device List',
          type: 'C',
          path: '/main/devices',
          icon: 'List'
        },
        {
          id: 302,
          name: isEn ? 'Device Template' : '设备模板',
          name_en: 'Device Template',
          type: 'C',
          path: '/main/templates',
          icon: 'Files'
        },
        {
          id: 303,
          name: isEn ? 'Gateway' : '网关管理',
          name_en: 'Gateway',
          type: 'C',
          path: '/main/gateways',
          icon: 'Link'
        }
      ]
    },
    {
      id: 4,
      name: isEn ? 'Data Center' : '数据中心',
      name_en: 'Data Center',
      type: 'M',
      path: '',
      icon: 'DataLine',
      children: [
        {
          id: 401,
          name: isEn ? 'Realtime Data' : '实时数据',
          name_en: 'Realtime Data',
          type: 'C',
          path: '/main/realTimeData',
          icon: 'Message'
        },
        {
          id: 402,
          name: isEn ? 'Realtime Plot' : '实时曲线',
          name_en: 'Realtime Plot',
          type: 'C',
          path: '/main/realtimeplot',
          icon: 'TrendCharts'
        },
        {
          id: 403,
          name: isEn ? 'History Record' : '历史记录',
          name_en: 'History Record',
          type: 'C',
          path: '/main/historyRecord',
          icon: 'Timer'
        }
      ]
    }
  ];
};

// ===== 加载项目菜单 =====
/*
const loadMenuData = async () => {
  try {
    const apiData = await fetchMenuDataFromAPI();
    const validData = Array.isArray(apiData) ? apiData : [];
    if (validData.length > 0) {
      menuItems.value = validData;
    } else {
      menuItems.value = getDefaultMenuData();
    }
    setDefaultMenu();
  } catch (error) {
    console.error('loadMenuData 错误:', error);
    menuItems.value = getDefaultMenuData();
    setDefaultMenu();
  }
};

const fetchMenuDataFromAPI = async () => {
  try {
    const queryParams = { pageNum: 1, pageSize: 50 };
    const res = await protocolbusinessList(queryParams);
    if (res && res.success && res.data && Array.isArray(res.data.list)) {
      return res.data.list.map(item => ({
        id: item.id,
        name: item.name || '未知项目',
        code: item.code || '',
        ...item
      }));
    }
    return [];
  } catch (error) {
    console.error('fetchMenuDataFromAPI 异常:', error);
    return [];
  }
};

const getDefaultMenuData = () => {
  return [
    { id: 1, name: 'Digi-RTU', code: 'DIGI_RTU' },
    { id: 2, name: 'PSP-DXR', code: 'PSP_DXR' },
    { id: 3, name: 'PSP-DXW', code: 'PSP_DXW' },
    { id: 4, name: 'PSP-CIR', code: 'PSP_CIR' }
  ];
};

const setDefaultMenu = () => {
  if ((route.path === '/main' || route.path === '/main/clientProjectDeail') && 
      menuItems.value.length > 0) {
    const currentBusinessId = route.query.businessId;
    const isValidBusinessId = menuItems.value.some(item => item.id == currentBusinessId);
    if (!isValidBusinessId) {
      const firstItem = menuItems.value[0];
      router.push({
        path: '/main/clientProjectDeail',
        query: { businessId: firstItem.id, businessName: firstItem.name }
      });
    }
  // }
};
*/
// ===== 语言切换 =====
const loadLocale = async (lang) => {
  try {
    const module = await import(
      `element-plus/dist/locale/${lang === "zh-CN" ? "zh-cn" : "en"}.mjs`
    );
    elLocale.value = module.default;
  } catch (error) {
    console.error("Failed to load locale:", error);
    const fallback = await import("element-plus/dist/locale/en.mjs");
    elLocale.value = fallback.default;
  }
};

const changeLang = async (lang) => {
  try {
    locale.value = lang;
    localStorage.setItem("lang", lang);
    await loadLocale(lang);

    const param = {
      lang: localStorage.getItem('lang') || 'en',
      UserId: 0,
      LangType: locale.value == 'zh-CN' ? 1 : 2,
      UserName: ''
    };
    await hanldChangeUserlang(param);
    
    // 重新加载菜单（刷新语言显示）
    await loadUserMenusFromService();
    
    ElMessage.success(t("message.common.langChanged"));
  } catch (error) {
    ElMessage.error(t("message.common.langChangeFailed"));
  }
};

// ===== 其他方法 =====
const toggleCollapse = () => store.commit("toggleMenu");

const handleCommand = (command) => {
  if (command === "logout") {
    handleWebApiLogout();
  } else if (command === "profile") {
    handleProfile();
  }
};

const handleProfile = () => {
  ElMessage.info(t("message.common.profileDeveloping"));
};

const handleWebApiLogout = async () => {
  try {
    await ElMessageBox.confirm(
      t("message.common.logoutConfirm"),
      t("message.common.tip"),
      {
        confirmButtonText: t("message.common.confirm"),
        cancelButtonText: t("message.common.cancel"),
        type: "warning",
      }
    );

    const token = sessionStorage.getItem("authToken");
    if (!token) {
      ElMessage.error(t("message.common.noToken"));
      router.push("/UserLogin");
      return;
    }

    try {
      const response = await loginOut();
      if (!response.success) {
        ElMessage.error(t("message.common.logoutFailed"));
      } else {
        ElMessage.success(t("message.common.logoutSuccess"));
      }
    } catch (error) {
      ElMessage.error(`${t("message.common.logoutFailed")}: ${error.message}`);
    }

    await store.dispatch("logout");
    router.push("/UserLogin");
  } catch (error) {
    if (error === "cancel") {
      ElMessage.info(t("message.common.logoutCancelled"));
      return;
    }
    ElMessage.error(t("message.common.logoutError"));
    await store.dispatch("logout");
    router.push("/UserLogin");
  }
};

// ===== 初始化加载语言 =====
loadLocale(locale.value);

// ===== 生命周期 =====
onMounted(async () => {
  // 先加载用户菜单权限
  await loadUserMenus();
  // 再加载项目菜单
  //await loadMenuData();
});

// ===== 监听语言变化 =====
watch(() => locale.value, () => {
  loadUserMenus();
});

// ===== 监听路由变化 =====
watch(
  () => route.fullPath,
  () => {
    console.log('路由变化:', route.fullPath);
  }
);
</script>

<style lang="scss" scoped>
.main-layout {
  height: 100%;
  overflow: hidden;
  display: flex;

  .layout-container {
    display: flex;
    flex: 1;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
  }

  .sidebar {
    height: 100vh;
    background-color: v-bind(menuBgColor);
    transition: width 0.3s;
    overflow: hidden;

    &.is-collapse {
      :deep(.el-submenu__title span),
      :deep(.el-menu-item span) {
        height: 0;
        width: 0;
        overflow: hidden;
        visibility: hidden;
        display: inline-block;
      }
    }

    .logo {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      background-color: #2b2f3a;
      cursor: pointer;

      span {
        margin-left: 10px;
      }

      .el-icon {
        font-size: 24px;
      }
    }

    .el-menu-vertical {
      border-right: none;
      background-color: v-bind(menuBgColor) !important;
      height: calc(100vh - 60px);
      overflow-y: auto;

      :deep(.el-submenu__title),
      :deep(.el-menu-item) {
        white-space: normal;
        height: auto !important;
        line-height: 1.5 !important;
        padding-top: 10px !important;
        padding-bottom: 10px !important;
        display: flex;
        align-items: center;

        span {
          display: inline-block;
          word-break: break-word;
          text-align: left;
        }

        .el-icon {
          flex-shrink: 0;
          margin-right: 8px;
        }
      }

      &.is-collapse {
        :deep(.el-menu-item) {
          white-space: nowrap;
          span {
            display: none;
          }
        }
      }

      :deep(.el-menu-item.is-active) {
        color: v-bind(menuActiveColor) !important;
        background-color: rgba(0, 0, 0, 0.2) !important;
      }
    }
  }

  .main-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    padding: 0 20px;
    z-index: 10;

    .header-left {
      display: flex;
      align-items: center;

      .collapse-btn {
        margin-right: 20px;
      }

      .breadcrumb {
        font-size: 14px;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 15px;

      .user-dropdown {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 14px;

        .el-icon {
          margin-left: 5px;
          font-size: 12px;
        }
      }

      .lang-switch {
        margin-left: 15px;

        .el-button {
          padding: 5px 10px;
          min-height: auto;
        }
      }
    }
  }

  .main-content {
    background-color: #f0f2f5;
    padding: 20px;
    flex: 1;
    overflow-y: auto;
    height: 0;

    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    &:hover {
      scrollbar-width: thin;
      &::-webkit-scrollbar {
        display: block;
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border-radius: 3px;
      }
    }
  }
}

.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>